import { z } from 'zod';
import { unitOfMeasureTypeSchema, IUnitOfMeasureType } from './unitOfMeasureType';

// Define the Zod schema for the form values
export const unitOfMeasureTypeFormSchema = unitOfMeasureTypeSchema;

/**
 * Default schema for unit of measure type form initialization.
 * Extends the form schema with form-specific fields and defaults.
 * Makes nonempty string fields optional with defaults.
 *
 * @property {string} name - Optional unit of measure type name
 */
export const unitOfMeasureTypeDefaultFormSchema = unitOfMeasureTypeFormSchema.extend({
    name: z.string().optional().default(''),
});

// TypeScript type for form values
export type IUnitOfMeasureTypeFormValues = z.infer<typeof unitOfMeasureTypeFormSchema>;

// Factory function to create form values
export const UnitOfMeasureTypeFormValues = (unitOfMeasureType ?: IUnitOfMeasureType) : IUnitOfMeasureTypeFormValues => {
    // Handle the default case (new unit of measure type)
    if (!unitOfMeasureType) {
        return unitOfMeasureTypeDefaultFormSchema.parse({});
    }

    // Transform the IUnitOfMeasureType data into IUnitOfMeasureTypeFormValues structure
    return unitOfMeasureTypeFormSchema.parse({
        ...unitOfMeasureType,
    });
};

// Validation function using the Zod schema
export const validateUnitOfMeasureTypeForm = (formValues : IUnitOfMeasureTypeFormValues) : boolean => {
    try {
        unitOfMeasureTypeFormSchema.parse(formValues);
        return true;
    } catch (error) {
        if (error instanceof z.ZodError) {
            // eslint-disable-next-line no-console
            console.error('Unit of measure type form validation failed:', error.errors);
        } else {
            // eslint-disable-next-line no-console
            console.error('An unexpected error occurred during validation:', error);
        }
        return false;
    }
};
